// utils/exportWalletTransaction.js

export const exportFields = {
    Date: "wt_date",
    Time: "wt_time",
    Cash: "wt_after_money",
    Credit: "wt_after_credit",
    Details: "wt_detail",
    Changed: {
        callback: (item) => {
            return parseFloat(
                parseFloat(item.wt_after_money) -
                parseFloat(item.wt_before_money) +
                (parseFloat(item.wt_after_credit) - parseFloat(item.wt_before_credit))
            ).toFixed(2);
        },
    },
};


export function getExportFileName(province, startDate, endDate) {
    let name = "Wallet_Transaction_Report";
    if (province) name += `_${province}`;
    if (startDate) name += `_from_${startDate}`;
    if (endDate) name += `_to_${endDate}`;
    return name;
}
